import { postSma } from "../../service/apiSma";

const CreateOTP = async (userId) => {
    try {
        const response = await postSma(`/user/${userId}/createOtp`, { appName: 'SmartPay' });
        return response;
    } catch (error) {
        console.error('Error CreateOTP:', error);
        throw error;
    }
};

export default CreateOTP;